import React, { useState } from "react";

import { useAppDispatch } from "../../../../../redux/hooks";

import ModalWrapper from "../../../../../components/Modal/ModalWrapper";
import CustomButton from "../../../../../components/CustomButton";
import Dropdown, {
  DropdownValue,
} from "../../../../../components/misc/Dropdown";

import {
  getCurrentYearOrMonth,
  monthsDataDropdownValue,
} from "../../../../../utils/dateAndTime";
import { fetchExportDeliveredPackagesReport } from "../../../../../redux/api/expedition.api";

const lastThreeYears = [
  getCurrentYearOrMonth("year"),
  getCurrentYearOrMonth("year") - 1,
  getCurrentYearOrMonth("year") - 2,
];

const yearsDataDropdownValue = lastThreeYears.map((year: number) => ({
  id: year,
  label: year,
}));

function withPackagesDeliveredReportModal<P>(
  WrappedComponent: React.ComponentType<P>,
) {
  function PackagesDeliveredReportModal(props: P) {
    const dispatch = useAppDispatch();

    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [selectedMonth, setSelectedMonth] = useState<DropdownValue>(
      monthsDataDropdownValue[getCurrentYearOrMonth("month", 1)],
    );
    const [selectedYear, setSelectedYear] = useState<DropdownValue>(
      yearsDataDropdownValue[0],
    );
    const [clientData, setClientData] = useState<{
      idClient: string;
      denumireClient: string;
    }>({
      idClient: "",
      denumireClient: "",
    });

    const handleCloseModal = () => {
      setIsLoadingSave(false);
      setShowModal(false);
    };

    const showPackagesDeliveryModal = ({
      idClient,
      denumireClient,
    }: {
      idClient: string;
      denumireClient: string;
    }) => {
      setClientData({
        idClient,
        denumireClient,
      });
      setShowModal(true);
    };

    const handleValidateCommand = () => {
      setIsLoadingSave(true);

      dispatch(
        fetchExportDeliveredPackagesReport({
          ...clientData,
          selectedMonth: selectedMonth.id,
          selectedYear: selectedYear.id,
        }),
      );
      handleCloseModal();
    };

    return (
      <>
        <ModalWrapper
          title={"Export raport colete livrate"}
          show={showModal}
          handleClose={handleCloseModal}>
          <div className="d-flex flex-wrap gap-2 mb-3">
            <Dropdown
              className="mb-2 me-2"
              title="Selecteaza luna"
              data={monthsDataDropdownValue}
              singleValue={selectedMonth}
              setSingleValue={(v) => v && setSelectedMonth(v)}
            />
            <Dropdown
              className="mb-2 me-2"
              title="Selecteaza anul"
              data={yearsDataDropdownValue}
              singleValue={selectedYear}
              setSingleValue={(v) => v && setSelectedYear(v)}
            />
          </div>

          <div className="d-flex justify-content-end">
            <CustomButton
              variant="contained"
              onClick={handleValidateCommand}
              loading={isLoadingSave}>
              Exporta CSV
            </CustomButton>
          </div>
        </ModalWrapper>

        <WrappedComponent
          {...(props as P)}
          showPackagesDeliveryModal={showPackagesDeliveryModal}
        />
      </>
    );
  }
  return PackagesDeliveredReportModal;
}

export default withPackagesDeliveredReportModal;
